export const APIResMessages = {
  S_W_R: "something went wrong",
};
export const CharacterLength = {
  sevenFive: 75,
  twoFiveSix: 256,
  fifty: 50,
  fiveHundred: 500,
  oneTwoFive: 125,
  hundred: 100,
};
